import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { api } from "../lib/api.js";
import { useI18n } from "../lib/i18n.jsx";
import NewPartsRequestDialog from "../components/NewPartsRequestDialog.jsx";
import ConfigurableTable, { ColumnConfigButton, useColumnConfig } from "../components/ConfigurableTable.jsx";
import SavedViewsBar from "../components/SavedViewsBar.jsx";
import PageHeader from "../components/PageHeader.jsx";

export default function PartsRequestsPage() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [showNew, setShowNew] = useState(false);
  const colConfig = useColumnConfig("parts_requests");

  const load = useCallback(() => {
    api.get("/parts-requests").then((r) => setList(r.data));
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-[1600px] mx-auto">
      <PageHeader
        overline="Peças"
        title={t("parts_requests")}
        subtitle={`${list.length} registo${list.length === 1 ? "" : "s"} — pedidos de peças (PCP).`}
        actions={
          <>
            <ColumnConfigButton config={colConfig} viewKey="parts_requests" />
            <button
              onClick={() => setShowNew(true)}
              className="inline-flex items-center gap-2 px-4 py-2 bg-ronil-navy hover:bg-ronil-navy-hover text-white rounded-md text-sm font-heading font-semibold shadow-sm hover:shadow-elevation transition-all"
              data-testid="pr-new-btn"
            >
              <Plus className="w-4 h-4" /> Novo pedido de peças
            </button>
          </>
        }
      />

      <div className="mb-3 px-1">
        <SavedViewsBar viewKey="parts_requests" config={colConfig} />
      </div>

      <ConfigurableTable viewKey="parts_requests" config={colConfig} rows={list} emptyMessage="Sem pedidos de peças" />

      {showNew && (
        <NewPartsRequestDialog
          onClose={() => setShowNew(false)}
          onCreated={(pr) => { setShowNew(false); navigate(`/parts-requests/${pr.id}`); }}
        />
      )}
    </div>
  );
}
